<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">先进集体评审学校管理</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-table id="table" :header-cell-style="tableStyle" border :data="topicSumData" style="width: 100%;margin-bottom: 20px;">
											<el-table-column prop="projectName" label="通知名称" width="350"></el-table-column>
											<el-table-column prop="declareEndTime" label="提交截止时间" width="155"></el-table-column>
											<el-table-column prop="trialEndTime" label="初审截止日期" width="155"></el-table-column>
											<el-table-column prop="trialByNumber" label="限报数量" width="80"></el-table-column>
											<el-table-column prop="submittedNum3" label="已提交" width="80"></el-table-column>
											<el-table-column prop="notNum" label="审核通过" width="80"></el-table-column>
											<el-table-column prop="unauditedNum" label="未审核" width="80"></el-table-column>
											<el-table-column prop="projectUnitName" label="操作">
												<template slot-scope="scope">
													<el-button type="text" @click="goRoute(scope.row)">进入审核</el-button>
												</template>
											</el-table-column>
										</el-table>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="pageNumber"
												:page-sizes="[50, 100, 200]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getProjectList } from '@/api/after/newInterface';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			topicSumData: [],
			underStudyTopicTotal: 10,
			pageNumber: 1,
			pageSize: 20,
			input: ''
		};
	},
	created() {
		this.getTable();
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val;
			this.getTable();
		},
		handleCurrentChange(val) {
			this.pageNumber = val;
			this.getTable();
		},
		goRoute(row) {
			this.$router.push({ path: `/backstage/processManageCollective?id=${row.id}` });
		},
		getTable() {
			let params = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				type: 4
			};
			getProjectList(params).then(res => {
				if (res.code == 200) {
					this.topicSumData = res.data.records;
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
}
.pagination {
	display: flex;
	justify-content: center;
}
</style>
